<template>
  <div
    @click="$store.commit('modals/OPEN_REDEMPTION_INSTRUCTIONS_POPUP', false)"
    class="py-3 md-pd flex items-center w-full h-full justify-center add-product__modal__container"
  >
    <section
      @click.stop
      class="w-full md:w-3/5 p-4 add-product__modal__container__chat relative"
    >
      <div
        @click="
          $store.commit('modals/OPEN_REDEMPTION_INSTRUCTIONS_POPUP', false)
        "
        class="flex absolute items-center justify-center cross-icon cursor-pointer z-20"
      >
        X
      </div>

      <div class="w-full flex flex-col gap-y-4">
        <div class="flex justify-between items-center">
          <p class="text-sm coupons-text">
            Add redemption instruction to be mailed to the user...
          </p>
        </div>
        <ckeditor
          :editor="editor"
          :config="editorConfig"
          v-model="editorContent"
        ></ckeditor>
        <vs-button @click="saveTemplate()"> Save Template </vs-button>
      </div>
    </section>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue2";
export default {
  name: "CKEditorModal",
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      orgId: "",
      editor: ClassicEditor,
      tokens: ["token1", "token2", "token3"],
      editorContent: "",
      editorConfig: {
        placeholder:
          "Create an email template by writting instructions. Use '@' to call dynamic coupon variables.",
      },
      typingTimerId: null,
    };
  },
  props: {},
  computed: {
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    redemptionInstructions() {
      return this.$store.state.market.orgProductRedemptionInstructions;
    },
  },
  watch: {
    orgData: {
      handler(newVal, oldVal) {
        if (
          newVal !== oldVal &&
          Object.keys(oldVal).length > 0 &&
          this.orgAssignments &&
          this.orgAssignments.length === 0
        ) {
          this.orgId = newVal._id;
        }
      },
      deep: true,
      setImmediate: true,
    },
  },
  created() {},
  methods: {
    close() {
      this.$store.commit("modals/OPEN_REDEMPTION_INSTRUCTIONS_POPUP", false);
    },
    saveTemplate() {
      this.parseTemplate();
      this.$store.commit(
        "market/ORG_PRODUCT_REDEMPTION_INSTRUCTIONS",
        this.editorContent
      );
      this.close();
    },
    parseTemplate() {
      const editorData = this.editorContent;
      const editorDataArr = editorData.split(" ").map((word) => {
        // only words that start with @ should be highlighted, not the words that include @
        if (word.startsWith("@")) {
          word = `<strong>${word}</strong>`;
        }
        return word;
      });

      this.editorContent = editorDataArr.join(" ");
    },
  },
  beforeMount() {
    this.editorContent = this.redemptionInstructions;
  },
};
</script>

<!-- <style lang="scss">
.ck-editor__editable {
  p {
    min-height: 200px !important;
  }
}
</style> -->

<style lang="scss" scoped>
.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: -0.5em;
  right: -0.5em;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  font-family: "Montserrat", Helvetica, Arial, serif;
  background: #fffffffa;
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}
.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgb(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.b-dropdown ::v-deep .dropdown-toggle {
  white-space: normal;
}

.add-product__modal {
  &__container {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 100000;
    &__chat {
      width: 35%;
      border-radius: 10px;
      background: #fff;
      .text {
        color: #1c1c1e;
      }
    }

    .vs-tooltip {
      z-index: 5200000;
    }
    .card {
      background: #ffffff;
      box-shadow: 6px 6px 29px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
    }
    .validate-btn {
      font-size: 1.2em;
      background: grey;
      color: #fff;
      border-radius: 10px;
    }
    .validate-icon {
      filter: invert(91%) sepia(34%) saturate(1988%) hue-rotate(321deg)
        brightness(99%) contrast(92%);
    }
    .choose-skill__chat {
      width: 25%;
      max-height: 27.5em;
      height: auto;
      // top: 17.5%;
    }

    .choose-skill {
      &__avatar {
        // width: 100%;
      }
      &__btns {
        .btn {
          padding: 1em;
          background-color: #82868b;
          color: #ffffff;
          width: 55%;
        }
      }
    }

    .overflow-container {
      max-height: 25em;
      overflow-y: scroll;
    }
  }
}

@media only screen and (max-width: 1400px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__btns {
          .btn {
            width: 70%;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          right: 2.75em;
          width: 32%;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      &__chat {
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          width: 50%;
          max-height: 75%;
          height: auto;
        }
      }
    }
  }
}

@media only screen and (max-width: 660px) {
  .add-product__modal {
    &__container {
      // &__chat {
      //   width: 95%;
      //   height: 75%;
      //   top: 3.5em;
      // }

      .choose-skill__chat {
        width: 95%;
      }
      .choose-skill {
        &__avatar {
          img {
            width: 25%;
          }
        }
      }
    }
  }
}
</style>
